import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { Modal } from "react-bootstrap";
import styles from "./GetInTouchPopup.module.scss";
import { getProfileName, profileTypeEndPoint } from "../ProfileHeader/profile-enum";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";

const blockedAccessTypeTexts = {
  // {
  //   type: "feature",
  //   text: "Upgrade your plan to access this feature."
  // },
  // {
  //   type: "dataset",
  //   text: "You do not have access to this data set. Connect with your account manager to get access."
  // }
  feature: "Upgrade your plan to access this feature.",
  dataset: "You do not have access to this data set. Connect with your account manager to get access.",
};

const GetInTouchPopup = ({ showGetInTouchPopup, handleGetInTouchClose, profileType, notifyCountry, blockAccessType, requestType }) => {
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const handleGetInTouchSubmit = () => {
    handleGetInTouchClose();
    const { user_active_plan } = creditDetails.data?.[0] ?? "";
    const planId = user_active_plan;
    const params = {
      planId,
      countries: notifyCountry ?? "",
      key: requestType ? requestType.split(" ").join("_").toLowerCase() : (getProfileName[profileType] ?? "Profile"),
    };
    axios
      .get(profileTypeEndPoint.getInTouch, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message, {
            position: blockAccessType === "feature" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
          });
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!", {
            position: blockAccessType === "feature" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
          });
        }
      })
      .catch(() => {
        toast.success("Something went wrong. Please try again later !!!", {
          position: blockAccessType === "feature" ? toast.POSITION.BOTTOM_RIGHT : toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  return (
    <div>
      <Modal show={showGetInTouchPopup} onHide={handleGetInTouchClose} keyboard={false} centered className={`trademo-modal ${styles.getInTouchModal}`}>
        <Modal.Header className={styles.modalHeader}>
          <Modal.Title>
            <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg`} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="tw-flex tw-flex-col tw-gap-1">
          <span>{requestType ? `You do not have access to ${requestType}. Connect with CSM to upgrade your plan.` : blockedAccessTypeTexts[blockAccessType]}</span>
          {STARTERPLAN && blockAccessType === "dataset" && (
            <span>
              <strong>Note:</strong> Each additional dataset will incur a charge of <strong>USD 150</strong> per month.
            </span>
          )}
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <button type="button" className="btn btn-secondary" onClick={handleGetInTouchClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary trademo-new-btn" onClick={handleGetInTouchSubmit}>
            Get in Touch
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GetInTouchPopup;
